import { ManagementModal } from "app/pages/sales-intelligence/common-components/modals/ManagementModal/ManagementModal";
import {
    SL_COMMON_NO,
    SL_COMMON_YES,
    SL_CONFIRM_QUIT_MODAL_DETAILS,
    SL_CONFIRM_QUIT_MODAL_TITLE,
} from "../../../translations/suppressionListKeys";
import { TITLE_STYLES, CUSTOM_STYLES } from "../style";
import { translate } from "app/filters/i18nFilter";

type ConfirmQuitModalProps = { onClose(): void; onConfirm(): void; isOpen: boolean };

export const ConfirmQuitModal = ({ onClose, onConfirm, isOpen }: ConfirmQuitModalProps) => {
    return (
        <ManagementModal
            customStyles={CUSTOM_STYLES}
            customTitleStyles={TITLE_STYLES}
            title={translate(SL_CONFIRM_QUIT_MODAL_TITLE)}
            details={translate(SL_CONFIRM_QUIT_MODAL_DETAILS)}
            isOpen={isOpen}
            onConfirm={onConfirm}
            onClose={onClose}
            cancelBtnText={SL_COMMON_NO}
            confirmBtnText={SL_COMMON_YES}
            confirmBtnType="primary"
            cancelBtnType="flat"
        />
    );
};
